var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7856 2.10575L9.3972 3C9.23673 2.42514 8.89967 1.91943 8.43663 1.55881C7.97359 1.19819 7.40956 1.0021 6.8292 1H2.6736C1.9651 1.00196 1.28616 1.29292 0.785179 1.8093C0.284193 2.32567 0.00190032 3.02546 0 3.75572L0 6.24428C0.00190032 6.97454 0.284193 7.67433 0.785179 8.19071C1.28616 8.70708 1.9651 8.99804 2.6736 9H6.8292C7.4094 8.99797 7.97332 8.80207 8.43634 8.44169C8.89936 8.0813 9.23651 7.57587 9.3972 7.00124L10.7856 7.89425C11.454 8.32468 12 8.01794 12 7.20037V2.79963C12 1.98701 11.454 1.67532 10.7856 2.10575Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00021 1.00012L1.00021 9.00012",
    stroke: "#D23333",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseVideo);
export default __webpack_public_path__ + "static/media/closeVideo.490e98932b812edbc306c5924d3bc413.svg";
export { ForwardRef as ReactComponent };